import { QueryClient } from "@tanstack/react-query";

export function createAppQueryClient() {
  return new QueryClient({ defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
    // Writes must fail immediately offline. Do not silently replay a message,
    // appointment or agent change when the browser regains connectivity.
    mutations: { networkMode: "always", retry: false },
  } });
}
